// extracted by mini-css-extract-plugin
export default {"copy_button":"styled_copy_button__6YWPK"};